// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"336":"58c2ae3c","376":"ea7de716","622":"93881f80","896":"f77e337f"}[chunkId] + ".chunk.css";
};